import { Actions, ActionTypes } from '@appStore/account/actions';
import { UserSettingOption } from '@enums';

export interface State {
  loading: boolean;
  loaded: boolean;
  filterViewSetting: UserSettingOption;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  filterViewSetting: null
};

export function reducer(state = initialState, action: Actions): State {

  switch (action.type) {
    case ActionTypes.AnalyzeFilterViewSettingLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.AnalyzeFilterViewSettingLoadSuccess:
      return { ...state, loaded: true, loading: false, filterViewSetting: action.payload.userSettingOptionState };

    case ActionTypes.AnalyzeFilterViewSettingLoadFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.AnalyzeFilterViewSettingUpdateSuccess:
        return {
          ...state,
          filterViewSetting: action.payload.userSettingOptionState
        };

  }
  return state;
}

export const getAnalyzeFilterViewSettings = (state: State) => state.filterViewSetting;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;

